export enum PrimarySectionSubheaderBlock {
  Root = 'PrimarySectionSubheader',
}
